import { IRect } from "../../interfaces/IRect";
import { ProjectService } from "../../services/project.service";
import { LedStripe } from "../profiles/led-stripe.model";
import { ElementType } from "../ToolboxModel";
import { ElementStoreModel } from "./element-store.model";

export class LedStripeStoreModel extends ElementStoreModel {

	rect: IRect;
	barId: string;
	stripeId: string;
	waste: number;
	length: number;

	constructor(c: LedStripe) {
		super(c.id, c.configId, c.tag, c.cuttingOnSite, c.inOffer);

		this.rect = c.rect;
		this.barId = c.bar.id;
		this.length = Math.round(c.getLength());
	}

	public static restore(c: LedStripeStoreModel, projectService: ProjectService) {
		const def = projectService.template.ledStripes.find(l => l.id == c.configId);
		const bar = projectService.profileService.roofElements[ElementType.Bar].find(b => b.id == c.barId);
		const stripe = new LedStripe(c.configId, bar, "LED Stripe", def.channels);
		stripe.id = c.id;
		stripe.setLength(c.length);
		projectService.profileService.roofElements[ElementType.LedStripe].push(stripe);
		return stripe;
	}

}
